import tick from 'assets/images/tick.svg';

export const subVendorVechileMatrix = (vehicleMatrixData)=>[
    {
        id:1,
        icon:tick,
        amt:vehicleMatrixData?.totalRides,
        name:"Total Rides"
    },
    {
        id:2,
        icon:tick,
        amt:vehicleMatrixData?.completedRides,
        name:"Completed Ride"
    },
]

export const editSubVehicleDialogData = (details) => [
    {
        placeholder: 'carModel',
        required: true,
        type: 'text',
        name: 'carModel',
        label: 'Car Model',
        star: '*',
        countrycode: false,
      },
      {
        placeholder: 'regNumber',
        required: true,
        type: 'text',
        name: 'regNumber',
        label: 'Reg Number',
        star: '*',
        countrycode: false,
      },
      {
        placeholder: 'color',
        required: true,
        type: 'text',
        name: 'color',
        label: 'Color',
        star: '*',
        countrycode: false,
      },
      {
        placeholder: 'fuelType',
        required: false,
        type: 'text',
        name: 'fuelType',
        label: 'Fuel Type',
        star: '*',
        countrycode: false,
      },
      {
        placeholder: 'seating',
        required: true,
        type: 'text',
        name: 'seating',
        label: 'Seating',
        star: '*',
        countrycode: false,
      },
      {
        placeholder:'rcOwner',
        required:'true',
        type:'text',
        name:'rcOwner',
        label:'RC Owner',
        star: '*',
      },
      {
        placeholder:'policyCompany',
        required:'true',
        type:'text',
        name:'policyCompany',
        label:'Policy Company',
        star: '*',
      },
      {
        placeholder:'policyNumber',
        required:'true',
        type:'text',
        name:'policyNumber',
        label:'Policy Number',
        star: '*',
      },
      {
        placeholder:'chasisNum',
        required:'true',
        type:'text',
        name:'chasisNum',
        label:'Chasis Number',
        star: '*',
      },
      {
        placeholder:'engineNum',
        required:'true',
        type:'text',
        name:'engineNum',
        label:'Engine Number',
        star: '*',
      },
      
    ];
